export const can = (user, perm) => {
  if (!user) return false;
  const p = user.permissions || [];
  return p.includes("*") || p.includes(perm);
};

export const canAny = (user, perms) => perms.some((p) => can(user, p));

export const canFinancial = (user) => can(user, "view_financial");

export const isConsultant = (user) => user?.role_name === "Consultant / Technician";
